import { z } from "zod";
import { baseSearchSchema } from "../-search-params";

export const transitionsSearchSchema = z.object({
	...baseSearchSchema.shape,
});

export type TransitionsSearch = z.infer<typeof transitionsSearchSchema>;

export const validateTransitionsSearch = (search: Record<string, unknown>): TransitionsSearch => {
	return transitionsSearchSchema.parse(search);
};
